<template>
    <div>
        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>Approbation par période</h5>
                </div>
                <vs-row>
                    <div class="flex -mx-2">
                        <div class="w-2/4 px-2">
                            <span class="vs-select--label">Période</span>
                            <date-range-picker
                                ref="picker"
                                :opens="opens"
                                :locale-data=locale
                                :singleDatePicker="false"
                                :timePicker=false
                                :showWeekNumbers="showWeekNumbers"
                                :showDropdowns="showDropdowns"
                                :autoApply="autoApply"
                                v-model="dateRange"
                                :ranges=false
                                @update="updateValues"
                                :linkedCalendars="linkedCalendars"
                                :dateFormat="dateFormat"
                                :always-show-calendars="false"
                                :alwaysShowCalendars="alwaysShowCalendars"
                                class="vs-inputx vs-input--input"
                            >
                                <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </div>
                            </date-range-picker>
                        </div>
                        <div class="w-3/4 px-2">
                            <span>Liste des manager</span>
                            <v-select v-model="manager" class="w-full" label="name"
                                placeholder="Sélectionner un manager"
                                :reduce="cat => cat.id"
                                :options="users">
                                <template v-slot:option="option">
                                    {{ option.name +' '+affiche(option.first_name) }}
                                </template>
                            </v-select>
                        </div>
                        <div class="w-1/8 px-2">
                            <vs-button :disabled="dateRange.startDate === '' || dateRange.endDate === ''" @click="makeSearch()" style="margin-top: 18px;" color="primary"
                                        type="filled" icon="search">Recherche
                            </vs-button>
                        </div>
                        <div class="w-1/8 px-2">
                            <vs-button :disabled="dateRange.startDate === '' || dateRange.endDate === ''" @click="makeSearchExport()" style="margin-top: 18px;" color="primary"
                                        type="filled" icon="search">Exporter
                            </vs-button>
                        </div>
                    </div>
                </vs-row><br><br>
                <div class="app-dashboard">
                    <div class="vx-row">
                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="primary"
                                    content-color="#fff">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold text-white"> {{ dma }} </h2>
                                        <span>DMA des approbations (H)</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold"> {{ received }} </h2>
                                        <span>Total approbation reçue</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="success" content-color="white">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 text-white"> {{ close }} </h2>
                                        <span>Total approbation fermée</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="danger" content-color="white">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold text-white"> {{ pedding }} </h2>
                                        <span>Total approbation en attente</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
    
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
import axios from "axios";
export default {
    name : "totalRequest",
    components: {DateRangePicker},
    data: () => ({
        dma: 0,
        received: 0,
        close: 0,
        pedding: 0,
        users: [],
        manager: '',
        opens: 'right',
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        locale: {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Appliquer',
            cancelLabel: 'Annuler',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
        },
        dateRange: {
            startDate: "",
            endDate: "",
        },
        dateFormat(classes, date) {
            let yesterday = moment().subtract(1, 'day');
            if (!classes.disabled) {
            }
        return classes
        },
    }),
    mounted(){
        this.dateRange.startDate = moment(new Date()).format('YYYY-MM-DD')
        this.dateRange.endDate = moment(new Date()).format('YYYY-MM-DD')
        this.makeSearch()
        this.getAgent()
    },
    methods:{
        updateValues(values) {
            this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },

        makeSearch(){
            this.$vs.loading()
            this.$http.post('/cex/request-approbation?export=0', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
                manager: this.manager
            }).then((response) => {
                let content = response.data
                this.dma = content['dma']
                this.received = content['received']
                this.close = content['close']
                this.pedding = content['progress']
                this.$vs.loading.close()
            }).catch((error) =>{
                this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },

        affiche(el){
            if (el != null){ return el }else return ''
        },

        getAgent(){
            //this.$vs.loading()
            this.$http.get('/users?paginate=0&profile=2').then((response) => {
                this.users = response.data
                //this.$vs.loading.close()
            }).catch((error) =>{
                //this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },
        
        makeSearchExport() {
            this.$vs.loading()
            axios({
            url: '/cex/request-approbation?export=1',
            method: 'POST',
            data: {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
                manager: this.manager
            },
            responseType: 'blob',
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'approbation.xlsx')
                document.body.appendChild(link)
                link.click()
                this.category = ''
                this.$vs.loading.close()
            }).catch((error) => {
                this.error_base = error.response.data.errors
                this.$vs.loading.close()
                if (error.response.status === 401) {
                    this.$vs.notify({
                    title: 'Erreur',
                    text: 'Votre session a expiré',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    position: 'top-right'
                    })
                    this.$router.push({name: "login"})
                }
            })
        },
    }
}
</script>

<style lang="scss">
  @import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>